import {
  APIReferenceAttributes,
  APIWorkspaceAttributes,
} from '@ardoq/api-types';
import { actionCreator } from '@ardoq/rxbeach';

export type UpdateLinkedWorkspacesPayload = {
  references: APIReferenceAttributes[];
  workspaces?: APIWorkspaceAttributes[];
};
export const updateLinkedWorkspaces =
  actionCreator<UpdateLinkedWorkspacesPayload>(
    '[models] UPDATE_LINKED_WORKSPACES'
  );
